import React from 'react'
import { Modal } from '@/shared/ui/Modal'
import { Button } from '@/shared/ui/Button'
import { AlertTriangle, CheckCircle, Info, XCircle } from 'lucide-react'
import { cn } from '@/lib/utils'

type Variant = 'info' | 'success' | 'warning' | 'error'

export type AlertModalProps = {
  open: boolean
  onClose: () => void
  title?: string
  description?: React.ReactNode
  variant?: Variant
  confirmText?: string
  onConfirm?: () => void
}

const variantMap: Record<Variant, { icon: React.ReactNode; color: string }> = {
  info: { icon: <Info className="h-5 w-5" />, color: 'text-foreground' },
  success: { icon: <CheckCircle className="h-5 w-5" />, color: 'text-green-500' },
  warning: { icon: <AlertTriangle className="h-5 w-5" />, color: 'text-yellow-500' },
  error: { icon: <XCircle className="h-5 w-5" />, color: 'text-destructive' },
}

export function AlertModal({ open, onClose, title = 'Alerta', description, variant = 'info', confirmText = 'OK', onConfirm }: AlertModalProps) {
  const v = variantMap[variant]
  const handleConfirm = () => {
    onConfirm?.()
    onClose()
  }
  return (
    <Modal open={open} onOpenChange={(v) => (!v ? onClose() : null)}>
      <div className="flex items-start gap-3">
        <div className={cn('mt-1', v.color)}>{v.icon}</div>
        <div className="flex-1">
          <h3 className="text-lg font-medium">{title}</h3>
          {description && <div className="mt-1 text-sm text-foreground/80">{description}</div>}
          <div className="mt-4 flex justify-end gap-2">
            <Button onClick={handleConfirm}>{confirmText}</Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
